export default __webpack_public_path__ + "static/media/hunter_walk_down.05946f3d.gif";